import { render, staticRenderFns } from "./EraserVariant.vue?vue&type=template&id=3ccfbb90"
import script from "./EraserVariant.vue?vue&type=script&lang=js"
export * from "./EraserVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports